import React, {useCallback, useContext, useState} from 'react';
import {Field, Form, Formik} from 'formik';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {Stack} from "@mui/material";
import Page from "../../components/ui/Page";
import {PageContext} from "@lb/mlib-components";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import PageContextZiggy from "../../store/page-context-ziggy";

const currentYearMonth = moment().format('YYYY-MM');

const initialValues = {
    endDate: currentYearMonth,
    startDate: currentYearMonth,
};

const excelDateToEpoch = (excelDate) => {
    return new Date(excelDate).getTime() / 1000;
};


export default function Logistics(props) {
    const [loading, setLoading] = useState(false);

    const pageCtx = useContext(PageContext);
    const pageCtxZiggy = useContext(PageContextZiggy);
    pageCtx.updateTitle('Reporting | Logistics')

    const handleDownload = useCallback(async (values) => {
        setLoading(true)

        const {startDate, endDate} = values;

        /* const startYearMonth = startDate ? moment(startDate).format('YYYY-MM') : '';
         const endYearMonth = endDate ? moment(endDate).format('YYYY-MM') : '';*/

        const startYearMonth = startDate ? excelDateToEpoch(startDate) : '';
        const endYearMonth = endDate ? excelDateToEpoch(endDate) : '';


        let url = `/logistics/report/order-details?start=${startYearMonth}&end=${endYearMonth}`;

        axios.get(url, {
            responseType: 'blob', headers: {'Error-Message': ''}
        }).then((response) => {

            const filename = `logistics_${startDate}_${endDate}.xlsx`;
            const urlObject = window.URL || window.webkitURL;
            const downloadUrl = urlObject.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                urlObject.revokeObjectURL(downloadUrl);
            }, 100);


        }).finally((error) => {
            setLoading(false)

        });

    }, [pageCtxZiggy.warehouse])


    return <Page>
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={loading}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
        <div style={{margin: '4vh'}}>

            <Formik initialValues={initialValues} onSubmit={handleDownload}>
                {(form) => (
                    <Form>

                        <Stack direction={'row'} spacing={2}>
                            <Field name="startDate">
                                {({field}) => (
                                    <TextField
                                        {...field}
                                        type="month"  // Use 'month' type for year and month input
                                        label="Start Date"
                                        InputLabelProps={{shrink: true}}
                                    />
                                )}
                            </Field>
                            <Field name="endDate">
                                {({field}) => (
                                    <TextField
                                        {...field}
                                        type="month"  // Use 'month' type for year and month input
                                        label="End Date"
                                        InputLabelProps={{shrink: true}}
                                    />
                                )}
                            </Field>


                            <Button type="submit"
                                    disabled={form.values.startDate.length === 0 || form.values.endDate.length === 0}
                                    variant="contained" color="primary"
                                    startIcon={<DownloadIcon/>}
                            >
                                Download
                            </Button>
                        </Stack>
                    </Form>)}
            </Formik>
        </div>
    </Page>
};
